import React from 'react'
import Link from 'gatsby-link'
import './job-list.css'

class JobList extends React.Component {
  state = {
    show: 60,
  }
  componentWillMount() {
    this.setState({ jobs: this.props.jobs })
  }
  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll.bind(this), true)
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll.bind(this), true)
  }
  handleScroll() {
    const bottom = window.innerHeight
    const scroll = document.body.getBoundingClientRect().bottom - 10
    if (scroll <= bottom) {
      this.showMore()
    }
  }
  showMore() {
    const currentlyShown = this.state.show
    if (this.state.show <= this.state.jobs.length)
      this.setState({ show: currentlyShown + 60 })
  }
  filterJobs(event) {
    event.target.value.length > 0
      ? this.setState({ filtered: true })
      : this.setState({ filtered: false })
    let updatedList = this.props.jobs
    updatedList = updatedList.filter(job => {
      const query = event.target.value.toLowerCase().replace(/\W/g, '')
      const title = job.node.title.toLowerCase()
      const company = job.node.company.toLowerCase()
      const tags = job.node.tags.join(' ').toLowerCase()
      if (
        title.search(query) !== -1 ||
        company.search(query) !== -1 ||
        tags.search(query) !== -1
      ) {
        return true
      }
      // return title.search(query) !== -1
    })
    this.setState({ jobs: updatedList })
  }
  render() {
    const style = {
      search: {
        display: 'block',
        width: '600px',
        maxWidth: '100%',
        margin: '0 auto',
        border: '0',
        borderRadius: '.25rem',
        padding: '1rem',
        boxShadow: '0 15px 35px rgba(50,50,93,.1), 0 5px 15px rgba(0,0,0,.07)',
        outline: '0',
        WebkitAppearance: 'none',
      },
    }

    return (
      <div>
        <div style={{ marginBottom: '3rem' }}>
          <input
            type="search"
            placeholder="Search jobs"
            onChange={this.filterJobs.bind(this)}
            style={{ ...style.search }}
          />
        </div>
        <ul className="job-list">
          {this.state.jobs.map((job, i) => {
            const hue = Math.round(
              Math.abs(
                ((job.node.company ? job.node.company.length : 10) *
                  (Math.ceil(1) - Math.floor(36)) +
                  1) *
                  20
              )
            )
            if (i < this.state.show)
              return (
                <li key={i} className="card">
                  <div className="card__image">
                    {job.node.company_logo ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          background: `url(${job.node.company_logo})`,
                          backgroundPosition: 'center',
                          backgroundSize: 'contain',
                          backgroundRepeat: 'no-repeat',
                          fontSize: '2em',
                          padding: '.25em .5em',
                          height: '3rem',
                          width: '3rem',
                          borderRadius: '.25rem',
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          background: `linear-gradient(45deg,hsl(${hue}, 50%, 60%), hsl(${hue}, 50%, 40%))`,
                          color: 'white',
                          fontSize: '2em',
                          padding: '.25em .5em',
                          lineHeight: '1',
                          height: '3rem',
                          width: '3rem',
                          textTransform: 'uppercase',
                          borderRadius: '.25rem',
                        }}
                      >
                        {job.node.company ? job.node.company.charAt(0) : '?'}
                      </div>
                    )}
                    <div className="card__detail">
                      <div>{job.node.company}</div>
                    </div>
                  </div>
                  <Link to={`/${job.node.slug}`}>
                    <h3 className="card__heading">{job.node.title}</h3>
                  </Link>
                  <div className="card__meta">
                    <div>
                      {job.node.tags
                        ? job.node.tags.map((tag, i) => {
                            return (
                              <span className="tag" key={i}>
                                {tag}
                              </span>
                            )
                          })
                        : ''}
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: '12px',
                      marginTop: 'auto',
                      lineHeight: 1,
                      color: 'hsla(211, 20%, 75%, 1)',
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontStyle: 'italic',
                      paddingTop: '.25rem',
                    }}
                  >
                    <span>{job.node.date_pretty}</span>
                    <span style={{ maxWidth: '50%' }}>{job.node.location}</span>
                  </div>
                  {job.node.logo ? (
                    <img className="card__logo" src={job.node.logo} />
                  ) : (
                    ''
                  )}
                </li>
              )
          })}
        </ul>
        <div
          style={{
            marginTop: '2em',
            padding: '2rem',
            background: 'hsla(210, 30%, 95%, 1)',
            borderRadius: '.25rem',
            textAlign: 'center',
          }}
          onClick={
            this.state.jobs.length <= this.state.show
              ? null
              : this.showMore.bind(this)
          }
        >
          {this.state.jobs.length <= this.state.show
            ? "That's all 🙌"
            : 'Load more 🎣'}
        </div>
      </div>
    )
  }
}

export default JobList



// WEBPACK FOOTER //
// ./src/components/job-list.js